import {StringHelper} from "./string.helper";

export class StorageHelper {

    public static has(key: string): boolean {
        return !!localStorage.getItem(this.buildKey(key));
    }

    public static get<T>(key: string, fallback?: T): T | undefined {
        key = this.buildKey(key);
        const storageValue = localStorage.getItem(key);
        if (!StringHelper.isFilledString(storageValue)) {
            return fallback;
        }

        try {
            return JSON.parse(storageValue!) as T;
        } catch (e) {
            return fallback;
        }
    }

    public static set<T>(key: string, value: T): void {
        const storageValue = JSON.stringify(value);
        localStorage.setItem(this.buildKey(key), storageValue);
    }

    public static remove(key: string): void {
        localStorage.removeItem(this.buildKey(key));
    }

    /**
     * The key as it really lands in `localStorage` — prefixed `ha.`, lower case, every run of `-`, `_` and
     * blanks folded into one `-`. Public so a reader of `storage` events (`event.key`) compares against
     * exactly this form instead of a copy of the rule (feature plan 0071, the stopwatch's second tab).
     */
    public static buildKey(key: string): string {
        return `ha.${key.toLowerCase().replaceAll(new RegExp('[\\- _]+', 'gm'), '-')}`;
    }

}